import React from 'react';
import { steps } from '../data/steps';
export function TransformationSteps() {
  return <section aria-labelledby="steps-heading" className="bg-white py-20 lg:py-28" data-id="element-132" data-mp="2ke2ciqbbilk8">
      <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-133" data-mp="2ffh9kj4olns3">
        <div className="max-w-2xl" data-id="element-134" data-mp="2fdwhr19r4ixx">
          <p className="text-[0.65rem] uppercase tracking-overline text-champagne-dark" data-id="element-135" data-mp="2bdw3phqke9re">
            The Process
          </p>
          <h2 id="steps-heading" className="mt-5 text-3xl font-light leading-[1.15] tracking-[-0.02em] text-ink sm:text-[2.75rem]" data-id="element-136" data-mp="26f2nvint26o2">
            Three steps to your transformation
          </h2>
        </div>

        <ol className="mt-14 grid gap-px border-t border-line md:grid-cols-3 md:bg-line lg:mt-20" data-id="element-137" data-mp="1wp9b4ebxfli8">
          {steps.map(step => <li key={step.number} className="group bg-white pb-10 pt-8 md:px-8 md:pt-10 md:first:pl-0 md:last:pr-0" data-id="element-138" data-mp="1no1r91a5qn7o">
              <span className="block text-sm font-medium tracking-[0.12em] text-champagne" data-id="element-139" data-mp="1iq08yikk2rx9">
                {step.number}
              </span>
              <h3 className="mt-6 text-xl font-normal tracking-[-0.01em] text-ink sm:text-2xl" data-id="element-140" data-mp="3hg8fwdfo3arw">
                {step.title}
              </h3>
              <p className="mt-4 text-[0.95rem] leading-[1.8] text-ink-soft" data-id="element-141" data-mp="33qeslzjt8yka">
                {step.description}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}